export const THEME_STORAGE_KEY = 'portfolio-theme'

export const themes = {
  maya: {
    label: 'MAYA (Default)',
  },
  red: {
    label: 'Red',
  },
  silver: {
    label: 'Silver',
  },
  blue: {
    label: 'Blue',
  },
  green: {
    label: 'Green',
  },
  pink: {
    label: 'Pink',
  },
}

export const isCustomThemeId = (themeId) =>
  typeof themeId === 'string' && themeId.startsWith('custom-')

export const getBuiltInThemeIds = () => Object.keys(themes)
